export default __webpack_public_path__ + "static/media/kwb.1b4c8451.png";